






















































































































































































































































































import { HelpCircleIcon, Edit1Icon } from 'tdesign-icons-vue';
import { defineComponent, computed, watch, ref } from '@vue/composition-api';
import CoLevelHelp, { helpHandler } from '@/renderer/components/dialog/AddTransfer/components/coLevelHelp.vue';
import FeatureMask from '@/renderer/components/common/Mask.vue';
import AddRoleDialog from '@/renderer/views/desktop/ManageConsole/InitializeSettings/components/addRole.vue';
import settingHandler from '@/renderer/views/desktop/ManageConsole/InitializeSettings/compositions/settingHandler';
export default defineComponent({
  components: {
    HelpCircleIcon,
    Edit1Icon,
    CoLevelHelp,
    FeatureMask,
    AddRoleDialog,
  },
  setup(props, context) {
    const {
      columns,
      roleList,
      sizeOptions,
      userFormData,
      teamFormData,
      orgSpace,
      userSizeInfo,
      teamSizeInfo,
      userSpaceConfig,
      teamSpaceConfig,
      currUserSizeMoreThanOrgSize,
      currUserSizeLessThanMinSize,
      minSizeStr,
      userSizeDisabled,
      userSaveDisabled,
      orgSaveDisabled,
      orgFormData,
      currTeamSizeMoreThanOrgSize,
      teamSizeDisabled,
      teamSaveDisabled,
      showAddRole,
      roleShowType,
      modifyData,
      methods: settingMethods,
    } = settingHandler();
    const { show: showHelp, openHelp } = helpHandler();
    const store = context.root.$store;
    // 非企业版屏蔽功能按钮
    const featureNotSupported = computed(() => store.getters.editionFlag !== 'enterprise');

    // 初始化查询企业剩余配额
    if (store.getters.editionFlag === 'enterprise') {
      settingMethods.getOrgSpaceInfo();
    }
    watch(
      () => userSizeInfo.size,
      val => {
        userSizeInfo.size = `${val}`.replace(/\D/g, '');
      },
    );
    watch(
      () => teamSizeInfo.size,
      val => {
        teamSizeInfo.size = `${val}`.replace(/\D/g, '');
      },
    );
    return {
      orgFormData,
      orgSaveDisabled,
      sizeOptions,
      userSpaceConfig,
      teamSpaceConfig,
      userFormData,
      teamFormData,
      userSizeInfo,
      teamSizeInfo,
      roleList,
      currUserSizeMoreThanOrgSize,
      currUserSizeLessThanMinSize,
      minSizeStr,
      userSizeDisabled,
      currTeamSizeMoreThanOrgSize,
      teamSizeDisabled,
      userSaveDisabled,
      teamSaveDisabled,
      featureNotSupported,
      orgSpace,
      columns,
      showHelp,
      openHelp,
      showAddRole,
      roleShowType,
      modifyData,
      ...settingMethods,
    };
  },
});
